<template>
    <div class="counterparty">
        <div class="panel-content">
            <b-table striped :items="org_items" :fields="fields">
                <template #cell(text_block)="row">
                    <div v-if="row.item.has_stop" >Контрагент знаходиться в чорному списку, за роз'ясненнями звертатися до керівництва ФЕБ</div>
                </template>
            </b-table>
        </div>
    </div>

</template>

<script >
export default {
    name: "mem_inside_bill",
    props : {
        "addon_data" : {
            type : Object
        },
        
        'mem' : {
            type : Object
        },
    },
    
    data() {
        return  {
            list_items : [],
            
            fields: [
                {
                    key: 'name',
                    label: 'Контрагент',
                    sortable: true
                },
                {
                    key: 'edrpou',
                    label: 'ЄДРПОУ',
                    sortable: true
                },
                
                {
                    key: 'text_block',
                    label: '',
                    
                },
            ],
        }
    },
    
    computed : {
        org_items() {
            if(this.addon_data.hasOwnProperty('items')) {
                return this.addon_data.items;
            }
            
            return [];
        },
    },
    
}
</script>


<style scoped>

</style>